"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __glob = (map) => (path) => {
  var fn = map[path];
  if (fn) return fn();
  throw new Error("Module not found in bundle: " + path);
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// build/commercetools/prod/customerGroups.json
var require_customerGroups = __commonJS({
  "build/commercetools/prod/customerGroups.json"(exports2, module2) {
    module2.exports = [{ id: "5bf35bca-011b-432e-a9bf-67b7473cdd0e", name: "Top 10 reseller", key: "Top_10_reseller" }, { id: "2fcec44d-ea30-4a61-80a7-ab09a3280699", name: "MKB Groot (algemeen)", key: "MKBGroot" }, { id: "aa61cf3d-e62e-4e3d-88a7-59e54dfa6ed1", name: "Reseller Groot (Sales)" }, { id: "a35619e8-df95-494e-9e2f-eb2560e9d251", name: "Resellers - Segmented pricing", key: "ResellersSegmentedPricing" }, { id: "931df1ad-0928-46db-9b95-6a2ea9805d93", name: "MKB Midden (Sales)" }, { id: "884e05ea-ae55-486a-bd6c-5517cf62bfd4", name: "Resellers To Be Checked", key: "ResellersToBeChecked" }, { id: "8dee2563-b347-4540-9758-fcde8f39fee9", name: "MKB Groot (Sales)" }, { id: "11205e2a-e745-4543-8855-6a8839f50d01", name: "Quotebutton", key: "Quotebutton" }, { id: "8c281811-5f09-48eb-ad9d-7cc835c8f39a", name: "Resellers Rejected", key: "ResellersRejected" }, { id: "6194b38c-3b9c-456b-bb69-54b6e441a2d4", name: "New Business" }, { id: "26386676-12b8-46b7-ad6a-ad6f48d5d558", name: "Printdeal top klant" }, { id: "4d494ef1-d148-40bc-ad47-df703429b584", name: "TEST SEGMENTED PLUS", key: "TESTSEGMENTEDPLUS" }, { id: "61f6068e-4e57-40b4-bb65-937ecdaba9c2", name: "TEST SEGMENTED PREMIUM", key: "TESTSEGMENTEDPREMIUM" }, { id: "3074b7f6-ae18-40d7-8cec-be560d3f5a7a", name: "Basic", key: "ResellersSegmentedBasic" }, { id: "ac8eb776-0b20-4fe2-9829-534d66440645", name: "Plus", key: "ResellersSegmentedPlus" }, { id: "08850988-348d-4e5e-ad8d-50d73b117c4a", name: "Premium", key: "ResellersSegmentedPremium" }, { id: "2fbbeed6-b4cb-454d-bd95-c733c5bccafe", name: "Bronze", key: "EndusersSegmentedBronze" }, { id: "5bf48edb-2115-4378-8f2c-ff5a83a3c552", name: "Silver", key: "EndusersSegmentedSilver" }, { id: "ddc55b15-0768-4dc7-9c3b-2b994a4dfd8d", name: "Gold", key: "EndusersSegmentedGold" }, { id: "a1decdc9-0411-413e-af3f-a027c170f9bd", name: "NOT CATEGORIZED", key: "EndusersSegmentedNotcategorized" }, { id: "8c9a4931-4f14-4b20-ac2f-cca0575042f4", name: "EndUser To Be Checked", key: "EndUserToBeChecked" }, { id: "33a99b5e-7cc1-4c18-bc83-d1a8f4ff013f", name: "Enduser Exclusive", key: "EnduserExclusive" }];
  }
});

// build/commercetools/staging/customerGroups.json
var require_customerGroups2 = __commonJS({
  "build/commercetools/staging/customerGroups.json"(exports2, module2) {
    module2.exports = [{ id: "b57698bc-905c-4935-8592-8683c075023b", name: "Pietje", key: "123" }, { id: "423bddf4-f431-4d0d-8050-024774efc523", name: "Test", key: "6473" }, { id: "973a5efb-f64b-48f2-a3c4-8d75e301b36e", name: "B2C", key: "B2C" }, { id: "8edad422-2356-4355-b611-62c9e1f5fbfb", name: "Segmented Pricing", key: "segmented-pricing" }, { id: "0b0a7210-f418-440b-9356-00510c743aaf", name: "B2B", key: "B2B" }, { id: "48b15a8d-b1b6-46f5-8798-6ad1d16fa812", name: "Test_Rick_Discounts", key: "Test-rick" }, { id: "fc3570ef-a542-463b-9c3b-a9213750f5bd", name: "Rick - test price segmentation", key: "Rick-test" }, { id: "dc5d65bd-0ccd-44f1-8677-13930807869a", name: "Resellers To Be Checked", key: "ResellersToBeChecked" }, { id: "c2e4ba8c-1be0-45ee-a578-efddff579e8e", name: "Reseller", key: "Reseller" }, { id: "530b70b1-8866-4932-96e5-b79443a511a8", name: "Unknown", key: "Unknown" }, { id: "5a8b8de8-ba8e-4179-897d-09b866eed73e", name: "Segmented Quote group", key: "segmentedQuote" }, { id: "22d6db4d-3ac2-49ce-8c99-942da5037bb7", name: "TEST SEGMENTED PREMIUM", key: "TESTSEGMENTEDPREMIUM" }, { id: "81957c57-41d3-48dc-8200-dd97f22f16e8", name: "TEST SEGMENTED PLUS", key: "TESTSEGMENTEDPLUS" }, { id: "075248fe-d028-42f0-acd7-be1a5dd2f0b9", name: "Test Jacco", key: "test-jacco" }, { id: "1517a92a-1f42-496d-8a88-25b6ac948df7", name: "EXP355-test-group", key: "EXP355-test-group" }, { id: "f07cf0f9-aed1-4e4c-b826-82c71b139a3c", name: "Gold", key: "EndusersSegmentedGold" }, { id: "70ff35f7-f25e-4f1e-aa4c-25aaa15dece7", name: "Silver", key: "EndusersSegmentedSilver" }, { id: "5138ccbb-45a4-4352-8237-7195e3b26bd6", name: "Bronze", key: "EndusersSegmentedBronze" }, { id: "ceaf44f3-3d82-47db-b16c-049e0f952010", name: "Premium", key: "ResellersSegmentedPremium" }, { id: "96b960e6-b471-4d66-9f51-15ae33d8e66b", name: "Plus", key: "ResellersSegmentedPlus" }, { id: "453d6cb6-f021-4913-a94e-42c446ee196e", name: "Basic", key: "ResellersSegmentedBasic" }, { id: "9919d299-7249-4363-8453-314f47c41fa7", name: "Resellers - Segmented pricing", key: "ResellersSegmentedPricing" }, { id: "cc76fe66-e989-478e-bee2-945b792e2959", name: "Groep Donkervliet", key: "hallo-vriendjes-en-vriendinnetjes" }, { id: "40bdb04a-0377-48ed-bd1d-e06c9b10ce88", name: "new group", key: "asdasd" }, { id: "088fb417-da0a-45b3-9f85-706179ea2a54", name: "testing rewardswallet", key: "testing123" }, { id: "f29ad409-609f-41f8-a919-aa4ef6c0fc16", name: "Test Discounts IH", key: "test_discounts_IH" }, { id: "4e45cbab-840a-4453-bbf1-5767d41de7f4", name: "Resellers Rejected", key: "ResellersRejected" }, { id: "4d1ad8ee-8ad2-4c91-a56c-70355490036c", name: "new", key: "gr" }, { id: "e585016d-4f87-414b-98cc-f75f86a6bb92", name: "EndUser To Be Checked", key: "EndUserToBeChecked" }];
  }
});

// build/commercetools/prod/states.json
var require_states = __commonJS({
  "build/commercetools/prod/states.json"(exports2, module2) {
    module2.exports = { lineItem: { WAITING_FOR_ARTWORK: "2748f11c-e9be-4dac-a566-7fd7beb6ef03", WAITING_FOR_DOC_REVIEW: "1fecdde8-7cf9-4338-abeb-8e8e435c2c55", WAITING_FOR_SECONDARY_DOC_REVIEW: "28007760-45bc-4345-9ed9-cc1267f48172", INITIAL: "8c982122-f1e9-4e57-9a1f-a6698835e876", PROCESSING: "c6ce5f15-8f7b-42c6-9fca-8b746c76e9c7", CONFIRMED: "0a4aaa63-5371-40d7-8898-d73769a4c0f3", DOC_REVIEW_PROOFING: "d4d229c0-ab37-4197-8f35-d3c6a19ddd90", WAITING_FOR_PROPOSAL: "aa5557a8-a3c9-4eff-8055-7d9f24f46c61", DOC_REVIEW_APPROVED: "d9dd6aba-3853-40dc-96cf-6f29c7bfc5a2", DOC_REVIEW_FAILED: "ff96f093-ccd9-4945-bbba-08ac2f4bf402", DOC_REVIEW_REJECTED: "ca1a4086-0868-4e19-a070-ad7295224d6a", DOC_REVIEW_IN_PROGRESS: "97cc0d7e-c480-46b0-8ede-8fcdb057b23c", DOC_FEEDBACK_REQUESTED: "f2ef3dfb-0ec9-49b2-9d23-0aeaf6a09e89", READY_FOR_FULFILLMENT: "8913c7ca-a4f9-41af-b840-5f50dbd2fe58", FULFILLMENT_REJECTED: "0ebfba27-8fd9-4ee4-95ff-d6605da27e77", FULFILLMENT_ACCEPTED: "b7179239-a425-4258-adf4-1b4b358afe8a", FULFILLMENT_ERROR: "eb60e270-e5b3-40ed-8ff4-71b8ffc4deac", PRINTING_IN_PROGRESS: "841d69e3-a3c4-4b08-80be-2dd2135b09e1", SHIPPED: "6004f7d5-62f9-47f4-9c3a-bbce100db3b1", CANCELLED: "ec6c5bf7-c17e-48f1-887d-e2d3e72c9baa", SENT_TO_MCP: "aaebef35-6498-4b28-b931-8cda1efda424", HELD: "e52fabe6-9fdc-478e-99c6-c17ea2069ac7", HOLD_FOR_INJECTION: "6f3b5fd0-4a6a-4b5b-a1eb-fad1f3652e90", PROCESSING_CLOUDLAB_ARTWORK: "07b35ece-4325-46de-b2a8-fd44f7d361a9", PROCESSING_CLOUDLAB_ARTWORK_DONE: "8b6d97d4-ae23-4870-9e51-68d064dd4abd", PROCESSING_CLOUDLAB_ARTWORK_FAILED: "956b77a7-d293-41b4-900b-a515ccef375d" }, order: { OPEN: "02b9ab6e-771c-4dd4-90d7-7d6bac598e26", PROCESSING: "28bf3ff0-f0a1-4c08-aec5-ebff1247994e", CONFIRMED: "60f77020-157e-47b6-8353-35ffd0293c4c", COMPLETED: "cd1d53e3-b0b2-48ec-b0f7-7f592595a934", CANCELLED: "b172736b-7655-4e8f-bce1-3a3c05466353" }, payment: { BALANCE_DUE: "BalanceDue", FAILED: "Failed", PENDING: "Pending", CREDIT_OWED: "CreditOwed", PAID: "Paid" }, service: { INITIAL: "8c982122-f1e9-4e57-9a1f-a6698835e876", CONFIRMED: "0a4aaa63-5371-40d7-8898-d73769a4c0f3", SERVICE_IN_PROGRESS: "4dfe5c74-9f86-4380-824a-aa4bb8500f7b", EDIT_IN_PROGRESS: "81243e66-29bf-410c-a872-e0924e568e16", SERVICE_DELIVERED: "a854787b-b165-45e2-a2be-0c7f07e55750", CANCELLED: "ec6c5bf7-c17e-48f1-887d-e2d3e72c9baa" } };
  }
});

// build/commercetools/staging/states.json
var require_states2 = __commonJS({
  "build/commercetools/staging/states.json"(exports2, module2) {
    module2.exports = { lineItem: { WAITING_FOR_ARTWORK: "f882cb8c-9a35-40c5-8528-c21b26acbf65", WAITING_FOR_DOC_REVIEW: "c76353df-541e-4a4f-8914-409f747a1a20", WAITING_FOR_SECONDARY_DOC_REVIEW: "604774b1-171d-4f49-adb6-3f1d613fa4b6", INITIAL: "76a76c0f-9da3-47f8-9923-1dc549ae6f00", PROCESSING: "a168736f-5fa9-421f-ad59-00084231dd3d", CONFIRMED: "37bb45cd-6449-4f7b-9209-5130aa80b059", DOC_REVIEW_PROOFING: "ea14106e-b678-4d73-a36d-84c265ea548e", WAITING_FOR_PROPOSAL: "d916a1d3-07c8-4056-a34b-de7cbc4da4b1", DOC_REVIEW_APPROVED: "079c4c5f-df1f-4bad-9fbc-79566d56eb97", DOC_REVIEW_FAILED: "265cf028-4b0e-457e-b22d-f3b82261459e", DOC_REVIEW_REJECTED: "ca773618-f97f-4e0c-afde-9adff64de087", DOC_REVIEW_IN_PROGRESS: "dbc2fabe-73b7-4a4e-82f9-5ff252e5bf5d", DOC_FEEDBACK_REQUESTED: "38cada67-5554-436f-b015-383836297f35", READY_FOR_FULFILLMENT: "daeb20b5-2edd-43df-b8a1-cdfaf8ab6d6b", FULFILLMENT_REJECTED: "30936627-6b38-42bd-8113-5422c3162c91", FULFILLMENT_ACCEPTED: "813e8f4c-e59d-493f-ace6-3d5b97531b64", FULFILLMENT_ERROR: "241c3011-c79f-42e4-9ada-7063c1da79f0", PRINTING_IN_PROGRESS: "71aa4579-bc9f-473f-b16b-89ba83b03458", SHIPPED: "51a1b3cf-2fd6-4868-846a-d83e45219f66", CANCELLED: "56fef091-b60a-4b2c-b7fb-0319798a0185", SENT_TO_MCP: "b3d20f5b-e2a6-4e48-889c-cce42b0f7c90", HELD: "3fe48643-dd34-4a58-96a8-f8c486d80610", HOLD_FOR_INJECTION: "c3f8529f-1518-46f3-8172-24572e07eb85", PROCESSING_CLOUDLAB_ARTWORK: "915b6194-c67c-40dd-bdab-3fa5b5d683a5", PROCESSING_CLOUDLAB_ARTWORK_DONE: "59cc274f-55db-46e2-8623-a6e44c28c57e", PROCESSING_CLOUDLAB_ARTWORK_FAILED: "1ff74ab8-8c8e-4e6f-8a46-d51fd606a2f5" }, order: { OPEN: "617956e5-7c27-4672-9ec6-f18f1e8e77aa", PROCESSING: "9562fb32-1232-4c8b-a7ed-09718bb44787", CONFIRMED: "b5240713-627a-4423-885e-41259e2d5507", COMPLETED: "56fd9a1d-5fc6-4fae-b66e-3b65078d4030", CANCELLED: "7c8cb863-6519-4bb1-a9b3-061d1ef540b9" }, payment: { BALANCE_DUE: "BalanceDue", FAILED: "Failed", PENDING: "Pending", CREDIT_OWED: "CreditOwed", PAID: "Paid" }, service: { INITIAL: "76a76c0f-9da3-47f8-9923-1dc549ae6f00", CONFIRMED: "37bb45cd-6449-4f7b-9209-5130aa80b059", SERVICE_IN_PROGRESS: "af4c0cfe-2bcf-490b-9e3c-a4e954f8ff08", EDIT_IN_PROGRESS: "1fb7b5cc-67ed-4022-859d-445935565773", SERVICE_DELIVERED: "f8572e4f-0758-4607-b13b-72cf765a5af1", CANCELLED: "56fef091-b60a-4b2c-b7fb-0319798a0185" } };
  }
});

// src/index.ts
var src_exports = {};
__export(src_exports, {
  CUSTOM_LINE_ITEM_TYPES: () => CUSTOM_LINE_ITEM_TYPES,
  DELIVERY_TOOLS: () => DELIVERY_TOOLS,
  LINE_ITEM_STATES: () => LINE_ITEM_STATES,
  ORDER_STATES: () => ORDER_STATES,
  PAYMENT_STATES: () => PAYMENT_STATES,
  SERVICES: () => SERVICES,
  SERVICES_WITHOUT_USER_ARTWORK: () => SERVICES_WITHOUT_USER_ARTWORK,
  SERVICE_ITEM_STATES: () => SERVICE_ITEM_STATES,
  areSomeLineItemsCancelled: () => areSomeLineItemsCancelled,
  artworkRequired: () => artworkRequired,
  canChangeShippingAddress: () => canChangeShippingAddress,
  getActiveArtworkServices: () => getActiveArtworkServices,
  getActiveCustomLineItemsService: () => getActiveCustomLineItemsService,
  getAssociatedGroupedLineItems: () => getAssociatedGroupedLineItems,
  getAttributeDescription: () => getAttributeDescription,
  getAvailableDeliveryToolsFromMRC: () => getAvailableDeliveryToolsFromMRC,
  getCategoryName: () => getCategoryName,
  getCauses: () => getCauses,
  getCustomLineItemsAdditionalAddresses: () => getCustomLineItemsAdditionalAddresses,
  getCustomLineItemsCustomerDiscount: () => getCustomLineItemsCustomerDiscount,
  getCustomLineItemsDeliveryService: () => getCustomLineItemsDeliveryService,
  getCustomLineItemsFileChange: () => getCustomLineItemsFileChange,
  getCustomLineItemsFileCheck: () => getCustomLineItemsFileCheck,
  getCustomLineItemsFileDesign: () => getCustomLineItemsFileDesign,
  getCustomLineItemsOfType: () => getCustomLineItemsOfType,
  getCustomLineItemsShipping: () => getCustomLineItemsShipping,
  getCustomerGroupNameById: () => getCustomerGroupNameById,
  getCustomerGroups: () => getCustomerGroups,
  getDependencyFlowStartItem: () => getDependencyFlowStartItem,
  getDependencyFlowStartItemState: () => getDependencyFlowStartItemState,
  getDependencyFlowState: () => getDependencyFlowState,
  getDependencyInformation: () => getDependencyInformation,
  getItemOrchestration: () => getItemOrchestration,
  getLineItemDescription: () => getLineItemDescription,
  getLineItemStateIdByName: () => getLineItemStateIdByName,
  getLineItemStateName: () => getLineItemStateName,
  getLinkedArtworkServices: () => getLinkedArtworkServices,
  getLinkedServiceNames: () => getLinkedServiceNames,
  getLinkedServices: () => getLinkedServices,
  getOrchestrationItemById: () => getOrchestrationItemById,
  getOrchestrationItemByRecipient: () => getOrchestrationItemByRecipient,
  getOrderStateName: () => getOrderStateName,
  getPickupPointHref: () => getPickupPointHref,
  getPreferredResolutions: () => getPreferredResolutions,
  getProductVariantVersion: () => getProductVariantVersion,
  getRequisitesLineItemIds: () => getRequisitesLineItemIds,
  getServiceGroups: () => getServiceGroups,
  getServiceName: () => getServiceName,
  getServiceStateName: () => getServiceStateName,
  getServices: () => getServices,
  getStateNameById: () => getStateNameById,
  getStates: () => getStates,
  getStatuses: () => getStatuses,
  getValidEditorTypeWithDocRef: () => getValidEditorTypeWithDocRef,
  hasActiveArtworkServiceOfTypes: () => hasActiveArtworkServiceOfTypes,
  hasActiveArtworkServices: () => hasActiveArtworkServices,
  hasAlternativelyUploaded: () => hasAlternativelyUploaded,
  hasCustomLineItemPricing: () => hasCustomLineItemPricing,
  hasDeliveredArtWorkService: () => hasDeliveredArtWorkService,
  hasDocumentReferenceComplete: () => hasDocumentReferenceComplete,
  hasLinkedServices: () => hasLinkedServices,
  hasManufactureReadyArtwork: () => hasManufactureReadyArtwork,
  hasOrchestration: () => hasOrchestration,
  hasPickupPoint: () => hasPickupPoint,
  hasProductVariantVersion: () => hasProductVariantVersion,
  hasReviewGroup: () => hasReviewGroup,
  hasSplitShipment: () => hasSplitShipment,
  isActiveCustomLineItemService: () => isActiveCustomLineItemService,
  isAlternativeUploadsUrl: () => isAlternativeUploadsUrl,
  isAnyUserArtworkNeeded: () => isAnyUserArtworkNeeded,
  isArtworkDelivered: () => isArtworkDelivered,
  isComplainable: () => isComplainable,
  isCustomLineItemOfType: () => isCustomLineItemOfType,
  isCustomerInAnyAllowedGroup: () => isCustomerInAnyAllowedGroup,
  isDependencyFlowStartItem: () => isDependencyFlowStartItem,
  isGroupLineItem: () => isGroupLineItem,
  isImage: () => isImage,
  isLineItemCancellable: () => isLineItemCancellable,
  isLineItemCancelled: () => isLineItemCancelled,
  isLineItemEditable: () => isLineItemEditable,
  isOrchestrationLineItemByRecipient: () => isOrchestrationLineItemByRecipient,
  isOrderCancellable: () => isOrderCancellable,
  isPaymentAgreed: () => isPaymentAgreed,
  isQuoteLineItem: () => isQuoteLineItem,
  isReorderable: () => isReorderable,
  isReviewGroupLead: () => isReviewGroupLead,
  isReviewedArtworkUploaded: () => isReviewedArtworkUploaded,
  isService: () => isService,
  isUserArtworkNeeded: () => isUserArtworkNeeded,
  needsArtwork: () => needsArtwork
});
module.exports = __toCommonJS(src_exports);

// src/artwork.ts
var hasManufactureReadyArtwork = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.manufacturingReadyDocumentUrl);
};
var hasDocumentReferenceComplete = (lineItem) => {
  var _a;
  return Boolean(((_a = lineItem.custom) == null ? void 0 : _a.fields.mcpDocumentsSource) && lineItem.custom.fields.userUploadComplete !== false);
};
var hasAlternativelyUploaded = (lineItem) => {
  var _a, _b;
  return Boolean(((_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.userUploadsUrl) == null ? void 0 : _b[0]) && lineItem.custom.fields.userUploadComplete);
};
var artworkRequired = (lineItem) => {
  var _a, _b, _c;
  return Boolean(((_c = (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.artworkRequired) == null ? void 0 : _b.trim()) == null ? void 0 : _c.toLowerCase()) === "yes");
};
var isReviewedArtworkUploaded = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.artworkUploadURL);
};
var isArtworkDelivered = (lineItem) => Boolean(hasAlternativelyUploaded(lineItem) || hasDocumentReferenceComplete(lineItem) || hasManufactureReadyArtwork(lineItem) || isReviewedArtworkUploaded(lineItem));
var needsArtwork = (order) => !order.lineItems.every((lineItem) => Boolean(hasAlternativelyUploaded(lineItem) || hasDocumentReferenceComplete(lineItem) || hasManufactureReadyArtwork(lineItem) || !artworkRequired(lineItem)));
var isReviewGroupLead = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.isReviewGroupLead);
};
var hasReviewGroup = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup);
};
var isImage = (contentType) => contentType.toLowerCase().match(/\.(gif|jpg|jpeg|png|tiff)+$/g);
var isAlternativeUploadsUrl = (lineItem) => {
  var _a;
  if ((_a = lineItem.custom) == null ? void 0 : _a.fields.userUploadsUrl) {
    const url = lineItem.custom.fields.userUploadsUrl;
    return url ? url.map((string) => string.split("::")).filter((subStr) => isImage(subStr[1]) !== null).flatMap((subStr) => subStr)[2] : null;
  }
  return null;
};

// src/complaint.ts
var isComplainable = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.mcpFulfillmentLineItemId);
};
var getCauses = () => ({
  // Note: Probably the id is not needed. Not sure if it is used in the application.
  DELIVERY_TOO_LATE: {
    id: "92f9182e-963f-45de-8b4a-ad350302d4ce",
    name: "Delivery to late",
    translationKey: "complaints.causes.deliveryToLate",
    mappedMcpKey: "Delivered too late||Internal Printdeal||"
  },
  NOT_FULLY_DELIVERED: {
    id: "7327742d-0b29-4b81-8c87-f16909e6d824",
    name: "Shipment not delivered or incomplete delivery",
    translationKey: "complaints.causes.notDeliveredOrIncomplete",
    mappedMcpKey: "Shipment not delivered or incomplete delivery||Internal Printdeal||"
  },
  DOES_NOT_MEET_EXPECTATIONS: {
    id: "fb08d29d-5944-4f13-ac0e-860fea0a5b5d",
    name: "Doesn't meet expectations",
    translationKey: "complaints.causes.doesntMeetExpectations",
    mappedMcpKey: "Doesn't meet expectations||Info correct, other expectation||"
  },
  DELIVERED_DAMAGED: {
    id: "92f9182e-963f-45de-8b4a-ad350302d4ce",
    name: "Delivered damaged",
    translationKey: "complaints.causes.deliveredDamaged",
    mappedMcpKey: "Delivered damaged||Internal Printdeal||"
  },
  DAMAGED_PRODUCT: {
    id: "7327742d-0b29-4b81-8c87-f16909e6d824",
    name: "Product damaged after use",
    translationKey: "complaints.causes.productDamaged",
    mappedMcpKey: "Product damaged after use||"
  }
});
var getPreferredResolutions = () => [
  {
    id: "d0d5c643-cc9b-493d-9ec2-cc97f0553951",
    name: "Reprint",
    translationKey: "complaints.resolutions.reprint",
    mappedMcpKey: "reprint"
  },
  {
    id: "542ba903-4b41-420f-b90d-068f9cf0a384",
    name: "(partial) refund",
    translationKey: "complaints.resolutions.partialRefund",
    mappedMcpKey: "refund"
  }
];
var getStatuses = () => [
  {
    name: "new",
    translationKey: "complaints.status.new",
    mcpComplaintsKey: "new",
    badgeColor: "blue"
  },
  {
    name: "in progress",
    translationKey: "complaints.status.inProgress",
    mcpComplaintsKey: "inProgress",
    badgeColor: "blue"
  },
  {
    name: "waiting for customer",
    translationKey: "complaints.status.waitingForCustomer",
    mcpComplaintsKey: "waitingForCustomer",
    badgeColor: "orange"
  },
  {
    name: "resolved",
    translationKey: "complaints.status.resolved",
    mcpComplaintsKey: "resolved",
    badgeColor: "green"
  },
  {
    name: "rejected",
    translationKey: "complaints.status.rejected",
    mcpComplaintsKey: "rejected",
    badgeColor: "gray"
  },
  {
    name: "cancelled",
    translationKey: "complaints.status.cancelled",
    mcpComplaintsKey: "cancelled",
    badgeColor: "gray"
  }
];

// require("../build/commercetools/**/*/customerGroups.json") in src/customerGroups.ts
var globRequire_build_commercetools_customerGroups_json = __glob({
  "../build/commercetools/prod/customerGroups.json": () => require_customerGroups(),
  "../build/commercetools/staging/customerGroups.json": () => require_customerGroups2()
});

// src/customerGroups.ts
var getCustomerGroups = (env) => globRequire_build_commercetools_customerGroups_json(`../build/commercetools/${env}/customerGroups.json`);
var getCustomerGroupNameById = (env, id) => {
  const customerGroups = getCustomerGroups(env);
  const foundCustomerGroup = customerGroups.find((customerGroup) => customerGroup.id === id);
  if (foundCustomerGroup) {
    return foundCustomerGroup.name;
  }
  return null;
};
var isCustomerInAnyAllowedGroup = (env, customerGroupIdOfCustomer, allowedCustomerGroups) => {
  const customerGroups = getCustomerGroups(env);
  return customerGroups.some((customerGroup) => allowedCustomerGroups.includes(customerGroup.key) && customerGroupIdOfCustomer === customerGroup.id);
};

// require("../build/commercetools/**/*/states.json") in src/states.ts
var globRequire_build_commercetools_states_json = __glob({
  "../build/commercetools/prod/states.json": () => require_states(),
  "../build/commercetools/staging/states.json": () => require_states2()
});

// src/states.ts
var SERVICE_ITEM_STATES = {
  INITIAL: "Initial",
  CONFIRMED: "Confirmed",
  SERVICE_IN_PROGRESS: "ServiceInProgress",
  EDIT_IN_PROGRESS: "EditInProgress",
  SERVICE_DELIVERED: "ServiceDelivered",
  CANCELLED: "Cancelled"
};
var LINE_ITEM_STATES = {
  WAITING_FOR_ARTWORK: "WaitingForArtwork",
  WAITING_FOR_DOC_REVIEW: "WaitingForDocReview",
  WAITING_FOR_SECONDARY_DOC_REVIEW: "WaitingForSecondaryDocReview",
  INITIAL: "Initial",
  PROCESSING: "Processing",
  CONFIRMED: "Confirmed",
  DOC_REVIEW_PROOFING: "DocReviewInProofing",
  WAITING_FOR_PROPOSAL: "WaitingForProposal",
  DOC_REVIEW_APPROVED: "DocReviewApproved",
  DOC_REVIEW_FAILED: "DocReviewFailed",
  DOC_REVIEW_REJECTED: "DocReviewRejected",
  DOC_REVIEW_IN_PROGRESS: "DocReviewInProgress",
  DOC_FEEDBACK_REQUESTED: "DocFeedbackRequested",
  READY_FOR_FULFILLMENT: "ReadyForFulfillment",
  FULFILLMENT_REJECTED: "FulfillmentRejected",
  FULFILLMENT_ACCEPTED: "FulfillmentAccepted",
  FULFILLMENT_ERROR: "FulfillmentError",
  PRINTING_IN_PROGRESS: "PrintingInProgress",
  SHIPPED: "Shipped",
  CANCELLED: "Cancelled",
  SENT_TO_MCP: "SentToMCP",
  HELD: "Held",
  HOLD_FOR_INJECTION: "HoldForInjection",
  PROCESSING_CLOUDLAB_ARTWORK: "ProcessingCloudlabArtwork",
  PROCESSING_CLOUDLAB_ARTWORK_DONE: "ProcessingCloudlabArtworkDone",
  PROCESSING_CLOUDLAB_ARTWORK_FAILED: "ProcessingCloudlabArtworkFailed"
};
var ORDER_STATES = {
  OPEN: "Open",
  PROCESSING: "Processing_order",
  CONFIRMED: "Confirmed_order",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled_order"
};
var PAYMENT_STATES = {
  BALANCE_DUE: "BalanceDue",
  FAILED: "Failed",
  PENDING: "Pending",
  CREDIT_OWED: "CreditOwed",
  PAID: "Paid"
};
var getStates = (env) => globRequire_build_commercetools_states_json(`../build/commercetools/${env}/states.json`);
var getStateNameById = (env, id) => {
  const {
    lineItem,
    order,
    service
  } = getStates(env);
  const [lineItemStateKey] = Object.entries(lineItem).find(([, value]) => id === value) || [];
  if (lineItemStateKey) {
    return LINE_ITEM_STATES[lineItemStateKey];
  }
  const [orderStateKey] = Object.entries(order).find(([, value]) => id === value) || [];
  if (orderStateKey) {
    return ORDER_STATES[orderStateKey];
  }
  const [serviceStateKey] = Object.entries(service).find(([, value]) => id === value) || [];
  if (serviceStateKey) {
    return SERVICE_ITEM_STATES[serviceStateKey];
  }
  return null;
};
var getLineItemStateIdByName = (env, stateName) => {
  const state = Object.entries(LINE_ITEM_STATES).find(([, value]) => stateName === value);
  if (!state) {
    return null;
  }
  const { lineItem } = getStates(env);
  const [stateKey] = state;
  return lineItem[stateKey];
};

// src/services.ts
var SERVICES = {
  FILE_DESIGN: "File Design",
  FILE_CHANGE: "File Change",
  FILE_CHECK: "File Check"
};
var SERVICES_WITHOUT_USER_ARTWORK = [SERVICES.FILE_DESIGN, SERVICES.FILE_CHANGE];
var getServices = (orderOrCart) => {
  const { customLineItems } = orderOrCart;
  if (customLineItems && customLineItems.length > 0) {
    const services = customLineItems.filter((customLineItem) => {
      var _a;
      return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === "service";
    });
    return services;
  }
  return [];
};
var getLinkedServices = (lineItemId, orderOrCart) => {
  const services = getServices(orderOrCart);
  const linkedServices = services.filter((service) => service.custom.fields.lineItemReference === lineItemId);
  return linkedServices;
};
var hasLinkedServices = (lineItemId, orderOrCart) => {
  const linkedServices = getLinkedServices(lineItemId, orderOrCart);
  return Boolean(linkedServices.length > 0);
};
var getServiceStateName = (service, env) => {
  const stateId = service.state[0].state.id;
  const name = getStateNameById(env, stateId);
  return name;
};
var getServiceName = (service) => service.custom.fields.serviceName;
var isService = (lineItem) => {
  var _a;
  return ((_a = lineItem.custom) == null ? void 0 : _a.fields.lineItemType) === "service";
};
var getLinkedServiceNames = (lineItemId, orderOrCart) => {
  const services = getLinkedServices(lineItemId, orderOrCart);
  const serviceNames = services.map((service) => getServiceName(service));
  return serviceNames;
};
var getLinkedArtworkServices = (lineItemId, orderOrCart) => {
  const VALID_ARTWORK_SERVICES = [
    SERVICES.FILE_DESIGN,
    SERVICES.FILE_CHANGE,
    SERVICES.FILE_CHECK
  ];
  const linkedServices = getLinkedServices(lineItemId, orderOrCart);
  const linkedArtworkServices = linkedServices.reduce((serviceLineItems, serviceLineItem) => {
    const linkedServiceName = getServiceName(serviceLineItem);
    if (!VALID_ARTWORK_SERVICES.includes(linkedServiceName)) {
      return serviceLineItems;
    }
    serviceLineItems.push(serviceLineItem);
    return serviceLineItems;
  }, []);
  return linkedArtworkServices;
};
var getActiveArtworkServices = (lineItemId, orderOrCart, env) => {
  const linkedArtworkServices = getLinkedArtworkServices(lineItemId, orderOrCart);
  if (linkedArtworkServices.length > 0) {
    return linkedArtworkServices.filter((artworkService) => getServiceStateName(artworkService, env) !== SERVICE_ITEM_STATES.CANCELLED);
  }
  return [];
};
var hasActiveArtworkServiceOfTypes = (lineItemId, orderOrCart, serviceNames, environment) => {
  const activeArtworkServices = getActiveArtworkServices(lineItemId, orderOrCart, environment);
  return activeArtworkServices.some((service) => serviceNames.includes(getServiceName(service)));
};
var hasActiveArtworkServices = (lineItemId, orderOrCart, enviroment) => Boolean(getActiveArtworkServices(lineItemId, orderOrCart, enviroment).length > 0);

// src/customLineItem.ts
var CUSTOM_LINE_ITEM_TYPES = {
  SHIPPING: "shipping",
  ADDITIONAL_ADDRESS: "additional-address-costs",
  CUSTOMER_DISCOUNT: "customerDiscount",
  DELIVERY_SERVICE: "deliveryService",
  SERVICE: "service"
};
var hasCustomLineItemPricing = (customLineItem) => {
  var _a, _b, _c, _d;
  return Boolean(((_b = (_a = customLineItem.taxedPrice) == null ? void 0 : _a.totalNet) == null ? void 0 : _b.centAmount) && ((_d = (_c = customLineItem.taxedPrice) == null ? void 0 : _c.totalGross) == null ? void 0 : _d.centAmount));
};
var isCustomLineItemOfType = (customLineItem, type) => {
  var _a;
  return Boolean(((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === type);
};
var getCustomLineItemsOfType = (customLineItems, type) => customLineItems.filter((customLineItem) => isCustomLineItemOfType(customLineItem, type));
var getCustomLineItemsShipping = (customLineItems) => getCustomLineItemsOfType(
  customLineItems,
  CUSTOM_LINE_ITEM_TYPES.SHIPPING
);
var getCustomLineItemsAdditionalAddresses = (customLineItems) => getCustomLineItemsOfType(
  customLineItems,
  CUSTOM_LINE_ITEM_TYPES.ADDITIONAL_ADDRESS
);
var getCustomLineItemsCustomerDiscount = (customLineItems) => getCustomLineItemsOfType(
  customLineItems,
  CUSTOM_LINE_ITEM_TYPES.CUSTOMER_DISCOUNT
);
var getCustomLineItemsDeliveryService = (customLineItems) => getCustomLineItemsOfType(
  customLineItems,
  CUSTOM_LINE_ITEM_TYPES.DELIVERY_SERVICE
);
var getCustomLineItemsFileDesign = (customLineItems) => customLineItems.filter((customLineItem) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_DESIGN);
var getCustomLineItemsFileChange = (customLineItems) => customLineItems.filter((customLineItem) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_CHANGE);
var getCustomLineItemsFileCheck = (customLineItems) => customLineItems.filter((customLineItem) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceName(customLineItem) === SERVICES.FILE_CHECK);
var getActiveCustomLineItemsService = (customLineItems, env) => customLineItems.filter((customLineItem) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceStateName(customLineItem, env) !== SERVICE_ITEM_STATES.CANCELLED);
var isActiveCustomLineItemService = (customLineItem, env) => isCustomLineItemOfType(customLineItem, CUSTOM_LINE_ITEM_TYPES.SERVICE) && getServiceStateName(customLineItem, env) !== SERVICE_ITEM_STATES.CANCELLED;

// src/orchestrations.ts
var hasOrchestration = (lineItem) => {
  var _a;
  return Boolean(((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestrationId) && lineItem.custom.fields.serviceGroup);
};
var isOrchestrationLineItemByRecipient = (lineItem, recipient) => {
  var _a;
  return Boolean(hasOrchestration(lineItem) && ((_a = lineItem.custom) == null ? void 0 : _a.fields.recipient) === recipient);
};
var getItemOrchestration = (lineItem) => {
  var _a;
  if (((_a = lineItem.custom) == null ? void 0 : _a.fields.orchestration) === void 0) {
    throw new Error(`No orchestration found on line item ${lineItem.id}`);
  }
  return JSON.parse(lineItem.custom.fields.orchestration);
};
var getServiceGroups = (lineItems) => {
  const orchestratedItems = lineItems.filter(hasOrchestration);
  return orchestratedItems.reduce((groups, lineItem) => {
    var _a;
    const serviceGroup = (_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup;
    if (serviceGroup) {
      if (groups[serviceGroup]) {
        groups[serviceGroup].push(lineItem);
      } else {
        groups[serviceGroup] = [lineItem];
      }
    }
    return groups;
  }, {});
};
var getDependencyInformation = (orderOrCart) => {
  var _a;
  try {
    const dependencyInformation = JSON.parse((_a = orderOrCart.custom) == null ? void 0 : _a.fields.dependencyInformation);
    return dependencyInformation;
  } catch (error) {
    return void 0;
  }
};
var isDependencyFlowStartItem = (lineItem, dependencyInformation) => {
  var _a, _b;
  const orchestrationserviceGroup = (_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup;
  if (!orchestrationserviceGroup) {
    return false;
  }
  const dependencyFlowGroup = dependencyInformation == null ? void 0 : dependencyInformation.dependencyFlow[orchestrationserviceGroup];
  if (!dependencyFlowGroup) {
    return false;
  }
  const startItem = dependencyFlowGroup.find((dependencyFlowItem) => dependencyFlowItem.priority === 0);
  return (startItem == null ? void 0 : startItem.itemKey) === ((_b = lineItem.custom) == null ? void 0 : _b.fields.productKey);
};
var getDependencyFlowStartItem = (lineItems, dependencyInformation) => {
  const startItem = lineItems.find((lineItem) => isDependencyFlowStartItem(lineItem, dependencyInformation));
  return startItem;
};
var getRequisitesLineItemIds = (lineItem, dependencyInformation) => {
  var _a;
  const lineItemId = lineItem.id;
  const serviceGroup = (_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup;
  const requisitesItemsId = [];
  dependencyInformation.dependencyFlow[serviceGroup].forEach((dependencyFlowItem) => {
    if (dependencyFlowItem.requisites.length === 0) {
      return;
    }
    dependencyFlowItem.requisites.forEach((requisite) => {
      if (requisite.lineItemId === lineItemId && dependencyFlowItem.lineItemId) {
        requisitesItemsId.push(dependencyFlowItem.lineItemId);
      }
    });
  });
  return requisitesItemsId;
};
var getDependencyFlowStartItemState = (lineItems, dependencyInformation, environment) => {
  var _a;
  const startItem = getDependencyFlowStartItem(lineItems, dependencyInformation);
  return (_a = startItem == null ? void 0 : startItem.state[0].state.id) != null ? _a : getLineItemStateIdByName(environment, "Processing");
};
var getDependencyFlowState = (lineItems, dependencyInformation, environment, fallbackState = "ReadyForFulfillment") => {
  var _a;
  const postInjectionStates = ["SentToMCP", "PrintingInProgress", "FulfillmentRejected", "Shipped"];
  if (lineItems.length === 0 || !dependencyInformation) {
    return getLineItemStateIdByName(environment, fallbackState);
  }
  const startItemStateId = getDependencyFlowStartItemState(lineItems, dependencyInformation, environment);
  const startItemState = getStateNameById(environment, startItemStateId);
  const allStatesTheSame = lineItems.every((lineItem) => lineItem.state[0].state.id === lineItems[0].state[0].state.id);
  if (allStatesTheSame) {
    return startItemStateId;
  }
  if (!postInjectionStates.includes(startItemState)) {
    return startItemStateId;
  }
  if (postInjectionStates.includes(startItemState) && startItemState !== "Shipped") {
    return getLineItemStateIdByName(environment, "ReadyForFulfillment");
  }
  const serviceGroup = (_a = lineItems[0].custom) == null ? void 0 : _a.fields.serviceGroup;
  const dependencyFlowGroup = dependencyInformation.dependencyFlow[serviceGroup];
  const startItem = dependencyFlowGroup == null ? void 0 : dependencyFlowGroup.find((dependencyFlowItem) => dependencyFlowItem.priority === 0);
  const shippedTriggers = startItem == null ? void 0 : startItem.triggers.Shipped;
  const nextItemKey = shippedTriggers == null ? void 0 : shippedTriggers[0].itemKey;
  const nextItem = lineItems.find((lineItem) => {
    var _a2, _b;
    return ((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.serviceKey) === nextItemKey || ((_b = lineItem.custom) == null ? void 0 : _b.fields.productKey) === nextItemKey;
  });
  if (startItemState === "Shipped" && nextItem) {
    return nextItem.state[0].state.id;
  }
  return getLineItemStateIdByName(environment, fallbackState);
};
var getOrchestrationItemById = (lineItems, id) => {
  const item = lineItems.find((lineItem) => {
    const orchestration = getItemOrchestration(lineItem);
    return orchestration.id === id;
  });
  if (!item) {
    throw new Error(`No orchestration item found with id ${id}`);
  }
  return item;
};
var getOrchestrationItemByRecipient = (lineItems, recipient) => {
  const item = lineItems.find((lineItem) => isOrchestrationLineItemByRecipient(lineItem, recipient));
  if (!item) {
    throw new Error(`No orchestration item found with recipient ${recipient}`);
  }
  return item;
};

// src/product.ts
var hasProductVariantVersion = (variant) => Boolean(variant.attributes.find((attr) => attr.name === "Product_Version___LOV"));
var getProductVariantVersion = (variant) => {
  const variantVersion = variant.attributes.find((attr) => attr.name === "Product_Version___LOV");
  return variantVersion ? variantVersion.value[0].key : "1";
};

// src/util.ts
function includes(coll, el) {
  return coll.includes(el);
}

// src/lineItem.ts
var getAttributeDescription = (lineItem, locale) => {
  if (!lineItem.custom) return null;
  const {
    isReviewGroupLead: isReviewGroupLead2,
    productDescription,
    reviewGroupLeadProductDescription,
    userSelection
  } = lineItem.custom.fields;
  const descriptions = isReviewGroupLead2 && reviewGroupLeadProductDescription ? reviewGroupLeadProductDescription : productDescription;
  if (descriptions && descriptions[locale]) {
    return descriptions[locale];
  }
  return userSelection == null ? void 0 : userSelection.map((selection) => {
    const [attribute, ...value] = selection.split(":");
    return `${attribute}: ${value.join(":")}`;
  }).join(", ");
};
var getCategoryName = (lineItem, locale) => {
  var _a;
  if ((_a = lineItem.custom) == null ? void 0 : _a.fields) {
    const {
      localizedProductName,
      merchandisingProductName
    } = lineItem.custom.fields;
    if (localizedProductName && localizedProductName[locale]) {
      return localizedProductName[locale];
    }
    const splitLocale = locale.split("-");
    return localizedProductName && localizedProductName[splitLocale[0]] ? localizedProductName[splitLocale[0]] : merchandisingProductName;
  }
  return null;
};
var getLineItemDescription = (lineItem, locale) => `${getCategoryName(lineItem, locale)}, ${getAttributeDescription(lineItem, locale)}`;
var getLineItemStateName = (lineItem, env) => {
  const stateId = lineItem.state[0].state.id;
  const name = getStateNameById(env, stateId);
  return name;
};
var isLineItemCancellable = (lineItem, env) => {
  const stateName = getLineItemStateName(lineItem, env);
  const ALLOWED_LINE_ITEM_STATES = [
    LINE_ITEM_STATES.INITIAL,
    LINE_ITEM_STATES.PROCESSING,
    LINE_ITEM_STATES.CONFIRMED,
    LINE_ITEM_STATES.HELD,
    LINE_ITEM_STATES.WAITING_FOR_ARTWORK,
    LINE_ITEM_STATES.WAITING_FOR_DOC_REVIEW,
    LINE_ITEM_STATES.WAITING_FOR_SECONDARY_DOC_REVIEW,
    LINE_ITEM_STATES.DOC_REVIEW_FAILED,
    LINE_ITEM_STATES.DOC_REVIEW_REJECTED,
    LINE_ITEM_STATES.PROCESSING_CLOUDLAB_ARTWORK_FAILED,
    LINE_ITEM_STATES.PROCESSING_CLOUDLAB_ARTWORK,
    LINE_ITEM_STATES.DOC_REVIEW_PROOFING,
    LINE_ITEM_STATES.WAITING_FOR_PROPOSAL
  ];
  return includes(ALLOWED_LINE_ITEM_STATES, stateName);
};
var isLineItemCancelled = (lineItem, env) => {
  const stateName = getLineItemStateName(lineItem, env);
  if (!stateName) return false;
  const ALLOWED_LINE_ITEM_STATES = [LINE_ITEM_STATES.CANCELLED];
  return includes(ALLOWED_LINE_ITEM_STATES, stateName);
};
var isGroupLineItem = (lineItem) => {
  if (!lineItem.custom) return false;
  const {
    reviewGroup,
    fulfillmentGroup,
    multipleDesignsGroup
  } = lineItem.custom.fields;
  return Boolean(reviewGroup || fulfillmentGroup || multipleDesignsGroup);
};
var hasSplitShipment = (lineItem) => {
  var _a;
  const shippingAddressPerLineItem = (_a = lineItem.custom) == null ? void 0 : _a.fields.shippingAddressPerLineItem;
  return Boolean(shippingAddressPerLineItem && shippingAddressPerLineItem.length > 1);
};
var isQuoteLineItem = (lineItem) => {
  var _a;
  const quoteId = (_a = lineItem.custom) == null ? void 0 : _a.fields.quoteId;
  return Boolean(quoteId);
};
var hasPickupPoint = (lineItem) => {
  var _a;
  return Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.isWithPickupLocation);
};
var getPickupPointHref = (lineItem) => {
  var _a;
  const pickupPointField = (_a = lineItem.custom) == null ? void 0 : _a.fields.pickupPoint;
  let href;
  if (pickupPointField) {
    try {
      href = JSON.parse(pickupPointField)[0].href;
    } catch (error) {
    }
  }
  return href;
};
var areSomeLineItemsCancelled = (lineItems, env) => lineItems.some((lineItem) => getLineItemStateName(lineItem, env) === LINE_ITEM_STATES.CANCELLED);
var isLineItemEditable = (env, lineItem, lineItems) => {
  const stateName = getLineItemStateName(lineItem, env);
  const someCancelled = areSomeLineItemsCancelled(lineItems, env);
  const isGrouped = isGroupLineItem(lineItem);
  const isSplitShipped = hasSplitShipment(lineItem);
  const isQuote = isQuoteLineItem(lineItem);
  const isPickupPoint = hasPickupPoint(lineItem);
  const isOrchestrated = hasOrchestration(lineItem);
  if (someCancelled || isGrouped || isSplitShipped || isQuote || isPickupPoint || isOrchestrated) {
    return false;
  }
  const disallowedStates = [
    LINE_ITEM_STATES.FULFILLMENT_REJECTED,
    LINE_ITEM_STATES.FULFILLMENT_ACCEPTED,
    LINE_ITEM_STATES.FULFILLMENT_ERROR,
    LINE_ITEM_STATES.PRINTING_IN_PROGRESS,
    LINE_ITEM_STATES.DOC_REVIEW_IN_PROGRESS,
    LINE_ITEM_STATES.WAITING_FOR_DOC_REVIEW,
    LINE_ITEM_STATES.WAITING_FOR_SECONDARY_DOC_REVIEW,
    LINE_ITEM_STATES.SHIPPED,
    LINE_ITEM_STATES.CANCELLED,
    LINE_ITEM_STATES.SENT_TO_MCP,
    LINE_ITEM_STATES.HELD,
    LINE_ITEM_STATES.PROCESSING_CLOUDLAB_ARTWORK
  ];
  return !includes(disallowedStates, stateName);
};
var isReorderable = (lineItem, checkProductVersion = false, reOrderableQuote = false) => {
  if (reOrderableQuote) {
    return true;
  }
  if (isQuoteLineItem(lineItem) || hasPickupPoint(lineItem)) {
    return false;
  }
  if (!checkProductVersion) {
    return true;
  }
  return getProductVariantVersion(lineItem.variant) !== "1";
};
var canChangeShippingAddress = (env, lineItem) => {
  const stateName = getLineItemStateName(lineItem, env);
  const disallowedStates = [
    LINE_ITEM_STATES.CANCELLED,
    LINE_ITEM_STATES.SHIPPED
  ];
  return !includes(disallowedStates, stateName);
};
var isUserArtworkNeeded = (orderOrCart, lineItem, env) => artworkRequired(lineItem) && !isArtworkDelivered(lineItem) && !isLineItemCancelled(lineItem, env) && !hasActiveArtworkServiceOfTypes(lineItem.id, orderOrCart, SERVICES_WITHOUT_USER_ARTWORK, env);
var isAnyUserArtworkNeeded = (orderOrCart, env) => orderOrCart.lineItems.some((lineItem) => isUserArtworkNeeded(orderOrCart, lineItem, env));
var getAssociatedGroupedLineItems = (orderOrCart, lineItem, settings) => {
  const {
    reviewGroup: lineItemReviewGroup,
    fulfillmentGroup: lineItemFulfillmentGroup,
    multipleDesignsGroup: lineItemMultipleDesignsGroup,
    serviceGroup: lineItemServiceGroup
  } = lineItem.custom.fields;
  const checkReviewGroup = lineItemReviewGroup && (settings ? settings.reviewGroup : true);
  const checkFulfillmentGroup = lineItemFulfillmentGroup && (settings ? settings.fulfillmentGroup : true);
  const checkMultipleDesignsGroup = lineItemMultipleDesignsGroup && (settings ? settings.multipleDesignsGroup : true);
  const checkServiceGroup = lineItemServiceGroup && (settings ? settings.serviceGroup : true);
  return orderOrCart.lineItems.filter((orderOrCartLineItem) => {
    if (orderOrCartLineItem.id === lineItem.id) {
      return false;
    }
    if (checkReviewGroup && orderOrCartLineItem.custom.fields.reviewGroup === lineItemReviewGroup) {
      return true;
    }
    if (checkFulfillmentGroup && orderOrCartLineItem.custom.fields.fulfillmentGroup === lineItemFulfillmentGroup) {
      return true;
    }
    if (checkMultipleDesignsGroup && orderOrCartLineItem.custom.fields.multipleDesignsGroup === lineItemMultipleDesignsGroup) {
      return true;
    }
    if (checkServiceGroup && orderOrCartLineItem.custom.fields.serviceGroup === lineItemServiceGroup) {
      return true;
    }
    return false;
  });
};

// src/order.ts
var getOrderStateName = (env, orderState) => {
  const stateId = orderState.id;
  return getStateNameById(env, stateId);
};
var isOrderCancellable = (env, orderState, lineItems) => {
  const orderStateName = getOrderStateName(env, orderState);
  const ALLOWED_ORDER_STATES = [
    ORDER_STATES.OPEN,
    ORDER_STATES.PROCESSING,
    ORDER_STATES.COMPLETED
  ];
  if (!includes(ALLOWED_ORDER_STATES, orderStateName)) {
    return false;
  }
  const hasUnCancellableLineItems = lineItems.some((lineItem) => !isLineItemCancellable(lineItem, env));
  return !hasUnCancellableLineItems;
};
var isPaymentAgreed = (order) => order.paymentState === PAYMENT_STATES.BALANCE_DUE;
var hasDeliveredArtWorkService = (order, env) => {
  const services = getServices(order);
  const serviceStateNames = [];
  if (services.length > 0) {
    services.forEach((service) => {
      const stateName = getServiceStateName(service, env);
      if (stateName) {
        serviceStateNames.push(stateName);
      }
    });
  }
  if (serviceStateNames.length > 0) {
    return !includes(serviceStateNames, "Cancelled") && (includes(serviceStateNames, "ServiceInProgress") || includes(serviceStateNames, "EditInProgress") || includes(serviceStateNames, "ServiceDelivered"));
  }
  return false;
};

// src/deliveryTool.ts
var DELIVERY_TOOLS = {
  CHECKMATE: "checkmate",
  PRINTQ: "printqeditor",
  DESIGN_AND_PRINT: "designandprint",
  ALTERNATIVE_UPLOAD: "alternative-upload",
  UPLOADER_TOOL: "uploaderTool"
};
var getAvailableDeliveryToolsFromMRC = (deliveryTool) => {
  const availableDeliveryTools = [];
  if (deliveryTool.checkmate === "on" && deliveryTool.checkmatemode === DELIVERY_TOOLS.CHECKMATE) {
    availableDeliveryTools.push(DELIVERY_TOOLS.CHECKMATE);
    availableDeliveryTools.push(DELIVERY_TOOLS.UPLOADER_TOOL);
  }
  if (deliveryTool.editor === "on" && deliveryTool.editormode === DELIVERY_TOOLS.PRINTQ) {
    availableDeliveryTools.push(DELIVERY_TOOLS.PRINTQ);
  }
  if (deliveryTool.editor === "on" && deliveryTool.editormode === DELIVERY_TOOLS.DESIGN_AND_PRINT) {
    availableDeliveryTools.push(DELIVERY_TOOLS.DESIGN_AND_PRINT);
  }
  if (deliveryTool.altUploadBeforeOrder === "on" || deliveryTool.altuploadbeforeorder === "on" || deliveryTool.editormode === DELIVERY_TOOLS.ALTERNATIVE_UPLOAD) {
    availableDeliveryTools.push(DELIVERY_TOOLS.ALTERNATIVE_UPLOAD);
  }
  return availableDeliveryTools;
};
var getValidEditorTypeWithDocRef = ({
  availableDeliveryTools,
  currentEditorType,
  docRef
}) => ({
  editorType: availableDeliveryTools.includes(currentEditorType) ? currentEditorType : availableDeliveryTools[0],
  docRef: availableDeliveryTools.includes(currentEditorType) ? docRef : null
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  CUSTOM_LINE_ITEM_TYPES,
  DELIVERY_TOOLS,
  LINE_ITEM_STATES,
  ORDER_STATES,
  PAYMENT_STATES,
  SERVICES,
  SERVICES_WITHOUT_USER_ARTWORK,
  SERVICE_ITEM_STATES,
  areSomeLineItemsCancelled,
  artworkRequired,
  canChangeShippingAddress,
  getActiveArtworkServices,
  getActiveCustomLineItemsService,
  getAssociatedGroupedLineItems,
  getAttributeDescription,
  getAvailableDeliveryToolsFromMRC,
  getCategoryName,
  getCauses,
  getCustomLineItemsAdditionalAddresses,
  getCustomLineItemsCustomerDiscount,
  getCustomLineItemsDeliveryService,
  getCustomLineItemsFileChange,
  getCustomLineItemsFileCheck,
  getCustomLineItemsFileDesign,
  getCustomLineItemsOfType,
  getCustomLineItemsShipping,
  getCustomerGroupNameById,
  getCustomerGroups,
  getDependencyFlowStartItem,
  getDependencyFlowStartItemState,
  getDependencyFlowState,
  getDependencyInformation,
  getItemOrchestration,
  getLineItemDescription,
  getLineItemStateIdByName,
  getLineItemStateName,
  getLinkedArtworkServices,
  getLinkedServiceNames,
  getLinkedServices,
  getOrchestrationItemById,
  getOrchestrationItemByRecipient,
  getOrderStateName,
  getPickupPointHref,
  getPreferredResolutions,
  getProductVariantVersion,
  getRequisitesLineItemIds,
  getServiceGroups,
  getServiceName,
  getServiceStateName,
  getServices,
  getStateNameById,
  getStates,
  getStatuses,
  getValidEditorTypeWithDocRef,
  hasActiveArtworkServiceOfTypes,
  hasActiveArtworkServices,
  hasAlternativelyUploaded,
  hasCustomLineItemPricing,
  hasDeliveredArtWorkService,
  hasDocumentReferenceComplete,
  hasLinkedServices,
  hasManufactureReadyArtwork,
  hasOrchestration,
  hasPickupPoint,
  hasProductVariantVersion,
  hasReviewGroup,
  hasSplitShipment,
  isActiveCustomLineItemService,
  isAlternativeUploadsUrl,
  isAnyUserArtworkNeeded,
  isArtworkDelivered,
  isComplainable,
  isCustomLineItemOfType,
  isCustomerInAnyAllowedGroup,
  isDependencyFlowStartItem,
  isGroupLineItem,
  isImage,
  isLineItemCancellable,
  isLineItemCancelled,
  isLineItemEditable,
  isOrchestrationLineItemByRecipient,
  isOrderCancellable,
  isPaymentAgreed,
  isQuoteLineItem,
  isReorderable,
  isReviewGroupLead,
  isReviewedArtworkUploaded,
  isService,
  isUserArtworkNeeded,
  needsArtwork
});
